<script module>
    export { default as layout } from '../../layouts/AdminLayout.svelte';
</script>

<script lang="ts">
    import { Link, useForm } from '@inertiajs/svelte';
    import { topics } from '@/routes/admin';
    import { store } from '@/routes/admin/topics';

    const form = useForm({
        name: '',
        disabled: false,
        not_for_credit: false,
    });

    function submit(e: Event) {
        e.preventDefault();
        $form.post(store.url(), { invalidateCacheTags: ['admin-topics'] });
    }
</script>

<svelte:head>
    <title>Add Topic — Admin — Case of the Day</title>
</svelte:head>

<div class="mb-6">
    <Link href={topics()} class="text-sm text-cyan-400 hover:text-cyan-300">&larr; Back to Topics</Link>
</div>

<h1 class="text-2xl font-bold text-gray-100 mb-6">Add Topic</h1>

<form onsubmit={submit} class="max-w-lg space-y-6">
        <div class="bg-gray-900 rounded-lg shadow border border-gray-700 p-6 space-y-4">
            <div>
                <label for="name" class="block text-sm font-medium text-gray-300 mb-1">Name</label>
                <input
                    id="name"
                    type="text"
                    bind:value={$form.name}
                    class="block w-full rounded-md border border-gray-700 bg-gray-800 text-gray-100 px-3 py-2 text-sm shadow-sm focus:border-cyan-500 focus:ring-cyan-500"
                />
                {#if $form.errors.name}<p class="text-red-500 text-sm mt-1">{$form.errors.name}</p>{/if}
            </div>

            <label for="disabled" class="flex items-center gap-3 cursor-pointer">
                <input
                    id="disabled"
                    type="checkbox"
                    bind:checked={$form.disabled}
                    class="h-4 w-4 rounded border-gray-700 text-cyan-600 focus:ring-cyan-500"
                />
                <div>
                    <span class="text-sm font-medium text-gray-300">Disabled</span>
                    <p class="text-xs text-gray-500">Disabled topics are not available for the current year.</p>
                </div>
            </label>

            <label for="not_for_credit" class="flex items-center gap-3 cursor-pointer">
                <input
                    id="not_for_credit"
                    type="checkbox"
                    bind:checked={$form.not_for_credit}
                    class="h-4 w-4 rounded border-gray-700 text-cyan-600 focus:ring-cyan-500"
                />
                <div>
                    <span class="text-sm font-medium text-gray-300">Not for credit</span>
                    <p class="text-xs text-gray-500">Marks this topic as "just for fun" — not counted toward scores.</p>
                </div>
            </label>
        </div>

        <div class="flex items-center gap-3">
            <button
                type="submit"
                disabled={$form.processing || !$form.name.trim()}
                class="bg-cyan-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-cyan-500 disabled:opacity-50 transition-colors"
            >
                {$form.processing ? 'Creating...' : 'Create Topic'}
            </button>
            <Link href={topics()} class="text-sm text-gray-500 hover:text-gray-300">Cancel</Link>
        </div>
    </form>
